import { Video } from "lucide-react";
import { SECTION_TYPES } from "../index";

const videoHeroSection = {
  type: SECTION_TYPES.VIDEO_HERO,
  content: {
    header: "Video Hero",
    subheader: "This is a video hero section",
    videoUrl:
      "https://ik.imagekit.io/4wu305uo4/customized-sections/vid-q4tjN9GJRyGYOGk6xWZjF.mp4?updatedAt=1725913817906",
  },
  meta: {
    displayName: "Video Hero",
    displayDescription: "First section on a page that plays a video in the background",
    displayIcon: Video,
  },
};

export default videoHeroSection;
